import React, { useEffect, useRef, useState } from "react";
import { AddCircleOutline, Delete, Edit } from "@mui/icons-material";
import { Button, IconButton, Tooltip } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import ReusableGrid from "../../components/ag grid/ReusableGrid";
import PageSizeSelector from "../../components/ag grid/PageSizeSelector";
import ExportButton from "../../components/ag grid/ExportButton";
import SubscripationPlanVeiwController from "../../redux/actions/SubscripationPlanApiAction";
import AddPlans from "./AddSubscripationPlans";

const PlansList = () => {
  const dispatch = useDispatch();
  const gridRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const [editPlan, setEditPlan] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const { getPlans, deletePlans } = SubscripationPlanVeiwController();
  const { plans } = useSelector((state) => state.subscripation);

  useEffect(() => {
    dispatch(getPlans());
  }, [dispatch]);

  const handleDelete = (id) => dispatch(deletePlans(id));
  const handleEdit = (plan) => {
    setEditPlan(plan);
    setShowModal(true);
  };

  const columnDefs = [
    { headerCheckboxSelection: true, checkboxSelection: true, maxWidth: 50, pinned: "left" },
    { headerName: "SR.No", valueGetter: (params) => params.node.rowIndex + 1, maxWidth: 80 },
    { headerName: "Name", field: "name", flex: 1 },
    { headerName: "Price (₹)", field: "price_per_employee", flex: 1 },
    { headerName: "Duration (Days)", field: "duration_days", flex: 1 },
    { headerName: "Features", field: "features", flex: 2 },
    {
      headerName: "Actions",
      field: "actions",
      pinned: "right",
      minWidth: 120,
      maxWidth: 150,
      cellRenderer: (params) => (
        <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
          <Tooltip title="Edit">
            <IconButton size="small" onClick={() => handleEdit(params.data)}>
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton
              size="small"
              sx={{ color: "#d32f2f" }}
              onClick={() => handleDelete(params.data.id)}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="d-flex flex-wrap mb-3" style={{ justifyContent: "space-between" }}>
        <Button
          variant="contained"
          startIcon={<AddCircleOutline />}
          onClick={() => { setEditPlan(null); setShowModal(true); }}
          sx={{ borderRadius: "8px", textTransform: "none" }}
        >
          Add Plan
        </Button>
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <ExportButton gridRef={gridRef} fileName="plans.xlsx" exportColumns={["name"]} />
          <PageSizeSelector pageSize={pageSize} onChange={(e) => setPageSize(Number(e.target.value))} />
        </div>
      </div>

      <div className="label-card">
        <Row className="justify-content-between w-100">
          <Col><h3>Subscription Plans</h3></Col>
        </Row>
      </div>

      <div className="list-grid-container" style={{ height: "70vh" }}>
        <ReusableGrid
          rowData={plans}
          columnDefs={columnDefs}
          gridRef={gridRef}
          pagination={true}
          pageSize={pageSize}
          onSelectionChanged={(rows) => setSelectedRows(rows)}
        />
      </div>

      <AddPlans
        show={showModal}
        handleClose={() => setShowModal(false)}
        initialData={editPlan}
      />
    </div>
  );
};

export default PlansList;
